import React, {useState, useEffect} from 'react';
import { rbac } from '../index';
import t from '../../../helpers/t';

import {resourcesActions, taskActions, userActions,resourceDefectsActions, useSelector} from "inbooma-api";              // necessary to communicate with inbooma-react api
import { Biscuit } from "../../../../utils";               // necessary to communicate with inbooma-react
import {moment} from "../../../../../vendor";

import Notification from "./Notification";
import {dateFormat} from "../../../../utils/FormatHelper";
import showNotification from "../../../helpers/showNotification";
import {getUserString} from "../../../../utils/Helper";
import ResourceDefectsDialog from "./ResourceDefects/ResourceDefectsDialog";
import CheckinsDialog from "./Checkins/CheckinsDialog";


const ItemView = (props) => {
    // initialize resource - set selected resource or set defaults
    const empty = {
        contingent_id: 0,
        longitude: "",
        client_id: Number(Biscuit.get('user.client_id')),
        latitude: "",
        location_id: 0,
        location_id_name: "",
        contingent_id_name: "",
        deleted: null,
        lock_type: null,
        advertiser: "",
        lock_key: "",
        mac: "",
        status: "active",
        secret: "",
        battery_value: null,
        name: "",
        note: "",
        resource_nbr: null,
        id: null,
        external_resource_id: null,
    };
    const [resource, setResource] = useState(
        (typeof props.resource.id === 'undefined') ? empty : props.resource
    );
    const [contingents, setContingents] = useState(props.contingents);

    const [notification,setNotification] = useState({
        message: "",
        show: false
    });
    let language = Biscuit.get('user.lang').replace('-','_');
    const [locations, setLocations] = useState(props.locations);
    const [initialized, setInitializeState] = useState(false);
    const [showLockKeys, setShowLockKeys] = useState((resource.lock_type !== null))
    const [itemState,setItemState] = useState('init');                                                  // init, saving
    const _patchRes = useSelector(state => state.resources_data.patchResource);                         // used for after save process
    const _postRes = useSelector(state => state.resources_data.postResource);                           // used for after save process

    const _tasks = useSelector(state => state.tasks.tasks);
    const _user = useSelector(state => state.users_data.user);
    const _deleteResourceDefect = useSelector(state => state.resource_defects_data.deleteResourceDefect);
    const [deleteResourceDefectPending, setDeleteResourceDefectPending] = useState(null);
    const [createdBy, setCreatedBy] = useState({
        id: null,
        first_name: '',
        last_name: ''
    });
    const [modifiedBy, setModifiedBy] = useState({
        id: null,
        first_name: '',
        last_name: ''
    });
    const [tempResourceDefect, setTempResourceDefect] = useState(null);
    const [tempIndex, setTempIndex] = useState(null);
    const [showResourceDefectsDialog, setShowResourceDefectsDialog] = useState(false);
    const [dialogCheckins,setDialogCheckins] = useState(null);
    const [showCheckinsDialog, setShowCheckinsDialog] = useState(false);
    useEffect(() =>{
        if(_deleteResourceDefect.success === '' || deleteResourceDefectPending === null){
            return;
        }
        if(_deleteResourceDefect.success === true){
            showNotification('success',deleteResourceDefectPending,'removed','defectResource');
            let clone = {};
            Object.assign(clone,resource);
            delete(clone.resource_defects[tempIndex]);
            setResource(clone);
        }else {
            let message = _deleteResourceDefect.data.message;

            showNotification('warning', deleteResourceDefectPending, message, 'defectResource');
        }
        setDeleteResourceDefectPending(null);
        setTempIndex(null);
    },[_deleteResourceDefect]);

    const _initialize = () => {

      if (itemState !=='pending_tasks') {
            // get tasks
            setItemState('pending_tasks');
            props.dispatch(taskActions.getTasks({
                filter: {
                    includes: "Users",
                    fk_model: "Resources",
                    fk_id: resource.id,
                    sort: "id",
                    direction: "desc"
                },
                token: Biscuit.get('token'),
                parameters: {
                    headers: {
                        'Accept-Language': language,
                        'Content-Language': language
                    }
                }
            }));
        }
        setInitializeState(true);
    };
    if(!initialized) _initialize();

    // evaluate form and send resource to api
    const onSubmit = () => {
/*
        if (resource.name === '') {
            // show notification, mark field as required
            setNotification({
                message: 'Das Feld "Bezeichnung" darf nicht leer sein!',
                show: true
            });
            return;
        }*/
        if (resource.contingent_id === 0) {
            // show notification, mark field as required
            setNotification({
                message: t('contingent_required'),
                show: true
            });
            return;
        }
        if (resource.location_id === 0) {
            // show notification, mark field as required
            setNotification({
                message: t('no_location_pick_one'),
                show: true
            });
            return;
        }
        let clone = {};
        Object.assign(clone,resource);
        if(clone.lock_type === null){
            clone.secret = null;
            clone.lock_key = null;
            clone.advertiser = null;
            clone.mac = null;
            clone.lock_battery = null;
            clone.ilockit_device_id = null;
            clone.unique_id = null;
            clone.firmware = null;
        }
        if(clone.id === null || isBlank(clone.resource_nbr)){
            clone.resource_nbr = null;
            setResource(clone);
        }

        if (typeof clone.id !== 'undefined' && clone.id !== null) {

            props.dispatch(resourcesActions.patchResource({
                resource_id: Number(clone.id),
                data: {
                    contingent_id: clone.contingent_id,
                    location_id: clone.location_id,
                    lock_type: clone.lock_type,
                    advertiser: clone.advertiser,
                    lock_key: clone.lock_key,
                    mac: clone.mac,
                    status: clone.status,
                    secret: clone.secret,
                    name: clone.name,
                    note: clone.note,
                    id: clone.id,
                    resource_nbr: clone.resource_nbr,
                    firmware: clone.firmware,
                    external_resource_id: clone.external_resource_id,
                },
                token: Biscuit.get('token'),
                parameters: {
                    headers: {
                        'Accept-Language': language,
                        'Content-Language': language
                    }
                }
            }));
        }
        else {
            props.dispatch(resourcesActions.addResource({
                data: {
                    ...resource
                },
                token: Biscuit.get('token'),
                parameters: {
                    headers: {
                        'Accept-Language': language,
                        'Content-Language': language
                    }
                }
            }));
        }
        setItemState('saving');
    };
    const currentUrl = new URL(window.location.href)
    const close = () => {
        props.setAdd(false);
        props.dispatch(resourcesActions.getResourceResetData());
        props.filterChangedHandle(props.filter);
        let requestPath = '';
        if(typeof props.requestPath !== 'undefined' && !props.requestPath.includes('/resources/'+resource.id) ){
            requestPath = props.requestPath;
        }
        let currentURL = "";
        if(!(currentUrl.search).includes('/resources/'+resource.id)){
            currentURL = currentUrl.search;
        }
        let returnUrl = (requestPath !== '')?requestPath + currentURL :`/resources${currentURL}`;
        window.location.replace(returnUrl);

        //props.setIndex(null);
       /* props.setResource([]);
        props.setIndex(null);
        //setToggleItemView(false);
        props.setAdd(false);
        alert('set Resource Changed');
        props.setResourcesPending(true);
        props.filterChangedHandle(props.filter);*/
       // props.onClose();

    };

    const getUsernameById = (id) => {

        if (typeof id === 'undefined' || id == null) return t('unknown',null,'capital');

        if (createdBy.id == id) {
            if (createdBy.first_name == '' && createdBy.last_name == '') return t('unknown',null,'capital');
            if (createdBy.first_name == '') return createdBy.last_name;
            if (createdBy.last_name == '') return createdBy.first_name;
            return createdBy.first_name + ' ' + createdBy.last_name;
        }

        if (modifiedBy.id == id) {
            if (modifiedBy.first_name == '' && modifiedBy.last_name == '') return t('unknown',null,'capital');
            if (modifiedBy.first_name == '') return modifiedBy.last_name;
            if (modifiedBy.last_name == '') return modifiedBy.first_name;
            return modifiedBy.first_name + ' ' + modifiedBy.last_name;
        }
        return t('unknown',null,'capital');
    };

    useEffect(() => {

        if (itemState !== 'saving') return;

        var isNewItem = (document.location.href.indexOf('add') >= 0);

        if (isNewItem) {
            if (_postRes.success === true) {
                props.showNotification('success', _postRes.data.id);
                props.dispatch(resourcesActions.getResourceResetData());
                props.setResource(null);
                abortButtonRef.current.click();
            } else if (_postRes.success === false) {
                props.showNotification('warning', 0, typeof _postRes.data !== 'undefined' ? _postRes.data.message : null);
                setItemState('init');
                props.dispatch(resourcesActions.getResourceResetData());
                props.setResource(null);
                abortButtonRef.current.click();
            }
        } else {
            if (_patchRes.success === true) {
                props.showNotification('success', _patchRes.data.id);
                props.dispatch(resourcesActions.getResourceResetData());
                props.setResource(null);
                abortButtonRef.current.click();
            } else if (_patchRes.success === false) {
                props.showNotification('warning', resource.id,typeof _patchRes.data !== 'undefined' ? _patchRes.data.message : null);
                setItemState('init');
                props.dispatch(resourcesActions.getResourceResetData());
                props.setResource(null);
                abortButtonRef.current.click();
            }
        }

      }, [_postRes,_patchRes]);

      useEffect(() => {

        if (itemState == 'pending_created' && resource.created_by == _user.data.id) {

            setCreatedBy({..._user.data});

            if (typeof resource.modified_by !== 'undefined' && resource.modified_by != null) {

                setItemState('pending_modified');
                props.dispatch(userActions.getUser({
                    token : Biscuit.get('token'),
                    id : resource.modified_by
                }));
            } else {
                setItemState('ready');
            }
            return;
        }

        if (itemState == 'pending_modified' && resource.modified_by == _user.data.id) {
            setModifiedBy({..._user.data});
            setItemState('ready');
            return;
        }
    }, [_user]);

    useEffect(() => {

        if (_tasks.success === true) {
            if (typeof resource.created_by !== 'undefined' && resource.created_by != null) {
                setItemState('pending_created');
                props.dispatch(userActions.getUser({
                    token: Biscuit.get('token'),
                    id: resource.created_by 
                }));
            } else if (typeof resource.modified_by !== 'undefined' && resource.modified_by != null) {
                setItemState('pending_modified');
                props.dispatch(userActions.getUser({
                    token: Biscuit.get('token'),
                    id: resource.modified_by
                }));
            } else {
                setItemState('ready');              // no user to request
            }
        }
    },[_tasks]);

    const onShowResourceDefectsDialog = (resourceDefect,index) => {
        setTempResourceDefect(resourceDefect);
        setTempIndex(index);
        setShowResourceDefectsDialog(true);
    }

    const onChangeForm = (e) => {

        let clone = {};
        Object.assign(clone, resource);
        if (typeof clone.id !== 'undefined' && clone.id !== null && clone.location_id === null && clone.checkins.length > 0) {
            setDialogCheckins(props.resource.checkins);
            setShowCheckinsDialog(true);
        } else {
            switch (e.target.name) {
                case 'name':
                    clone.name = e.target.value;
                    break;
                case 'external_resource_id':
                    clone.external_resource_id = e.target.value;
                    break;
                case 'status':
                    clone.status = e.target.value;
                    break;
                case 'lock_type':
                    if (e.target.value === 'hash') {
                        clone.secret = "";              // reset secret cause it belongs to lock type 'token'
                    }
                    if (e.target.value === 'token') {
                        clone.lock_key = "";            // reset lock_key cause it belongs to lock type 'hash'
                    }
                    if (e.target.value === "Kein Schloss") {
                        if (resource.id === null || confirm(t('warning delete lock'))) {
                            clone.secret = null;
                            clone.lock_key = null;
                            clone.advertiser = null;
                            clone.mac = null;
                            clone.lock_type = null;
                            clone.lock_battery = null;
                            clone.ilockit_device_id = null;
                            clone.unique_id = null;
                            setShowLockKeys(false);
                        }
                    } else {
                        clone.lock_type = e.target.value;
                        setShowLockKeys(true);
                    }
                    break;
                case 'lock_key':
                    clone.lock_key = e.target.value;
                    break;
                case 'secret':
                    clone.secret = e.target.value;
                    break;
                case 'advertiser':
                    clone.advertiser = e.target.value;
                    break;
                case 'mac_adress':
                    clone.mac = e.target.value;
                    break;
                case 'note':
                    clone.note = e.target.value;
                    break;
                case 'resource_nbr':
                    if (isBlank(e.target.value)) {
                        e.target.value = null;
                    }
                    clone.resource_nbr = e.target.value;
                    break;
            }
            setResource(clone);             // set object state
        }
    };
    const isBlank = (str) => {
        return (!str || /^\s*$/.test(str));
    }

    const onChangeLocation = (location) => {
        let clone = {};
        Object.assign(clone, resource);
        if (typeof clone.id !== 'undefined' && clone.id !== null && clone.checkins.length > 0) {
            setDialogCheckins(props.resource.checkins);
            setShowCheckinsDialog(true);
        } else {
            clone.location_id = Number(location.target.value);
            setResource(clone);
        }
    };

    const onChangeContingent = (contingent) => {
       // setLocations(null);
        let clone = {};
        Object.assign(clone, resource);
        if (typeof clone.id !== 'undefined' && clone.id !== null && clone.location_id === null && clone.checkins.length > 0) {
            setDialogCheckins(props.resource.checkins);
            setShowCheckinsDialog(true);
        } else {
            clone.contingent_id = Number(contingent.target.value);
            //clone.location_id="";
            setResource(clone);
        }
       /* const callback = (response) => {
            if (response.success) {
                setLocations(response.data.locations);
            } else {
                props.dispatch(alertsActions.addAlert({
                    message : t('error_contingent_access_forbidden'),
                    icon : 'fi fi-x',
                }));
            }
        };
        props.dispatch(contingentsActions.getContingent({
            id: contingent.target.value,
            callback,
            token: Biscuit.get('token')
        }));*/

    };

    const del = (defectId, index) => {
        if (confirm(t('really_remove'))) {
            props.dispatch(resourceDefectsActions.deleteResourceDefect(
                {
                    token: Biscuit.get('token'),
                    resource_defect_id: defectId
                }
            ));
            setTempIndex(index);
            setDeleteResourceDefectPending(defectId);
        }
    }

    const handleCloseDialog = (e) => {
        setShowResourceDefectsDialog(false);
        setShowCheckinsDialog(false);
        setTempIndex(null);
        setDialogCheckins(null);
    }

    const closeNotification = () => {

        setNotification({
            ...notification,
            show: false
        });
    };
    const abortButtonRef = React.createRef();
    let returnUrl = (typeof props.requestPath !== 'undefined')?props.requestPath + currentUrl.search + currentUrl.search :`/resources${currentUrl.search}`;
    let hasTaskTeamLead = false;
    let si = 6;
    if(resource.id !== null && resource.firmware !== null){
        si = 4;
    }
    return (
      <>
        <div className='js-off-canvas-overlay is-overlay-fixed is-visible'></div>
        {notification.show &&
        <>
            <Notification
            message={notification.message}
            close={closeNotification}>
            </Notification>
        </>
        }
        {rbac.hasPermission('configureResource') && !showResourceDefectsDialog &&
        <div className="off-canvas position-right is-transition-overlap is-open" id="inb-off-canvas" data-off-canvas="85mrb3-off-canvas" data-close-on-click="true" aria-hidden="false">
            <header className="inb-header off-canvas__header off-canvas--shadow clearfix row">
                <h1 className="inb-page-title">{(resource.id !== null)?t('edit_${a}',{a:t('resource',null,'capital')}):t('add_${a}',{a:t('resource',null,'capital')})}</h1>
                <div className="off-canvas__actions column">
                    <button type="submit" className={"button medium beautify beautify-" + Biscuit.get('user.client_id')+ " button-submit round"} title="Speichern" onClick={onSubmit}>
                    {itemState != 'saving' &&
                        <>
                          <i className="fi fi-check"></i>
                          <span>{t('save')}</span>
                        </>
                        }
                        {itemState == 'saving' &&
                          <span><img className="rollingLoader" src="assets/img/rolling_loader.svg" />{t('save')}</span>
                        }
                    </button>
                    <a
                        href='#'>
                        <button ref={abortButtonRef} type="button" id="inb-resourcesform-abort-button" className="button hollow secondary right button-abort round" title="Fenster schließen" onClick={() => close()}>
                            <i className="fi fi-x"> </i>
                        </button>
                    </a>
                </div>
            </header>
            { typeof resource.id !== 'undefined' && resource.id != null &&
                <p className="off-canvas__subtitle off-canvas__header-region">
                    {typeof resource.created !== 'undefined' &&
                    t('created_at') + " " + moment(resource.created).format('DD.MM.YYYY HH:mm:ss') + " " + 
                    t('edited_by') + " " + getUsernameById(resource.created_by) + " | " +
                    t('last_modified_at') + " " + moment(resource.modified).format('DD.MM.YYYY HH:mm:ss') + " " + 
                    t('edited_by') + " " + getUsernameById(resource.modified_by)
                    }
                </p>
            }

            <form className="off-content row">

                <div className="inb-form-group column medium-8 small-8 username">
                    <label className="inb-form__controlLabel">{t('name')}</label>
                    <div className="inb-form__controllClass">
                        <input id="resource_item_input_name" type="text" className="form-control" name="name" required="" autoComplete="false"placeholder="" value={resource.name} onChange={onChangeForm}/>
                    </div>
                </div>

                <div className="inb-form-group column medium-4 small-4 status">
                    <label className="inb-form__controlLabel">{t('status')}</label>
                    <div className="inb-form__controllClass">
                        <select
                            className="inbooma-select-box__input"
                            name="status"
                            onChange={e => onChangeForm(e)}
                            value={resource.status === null ? '' : resource.status}
                            disabled={!rbac.hasPermission('editStatus')}
                            placeholder={t('select_${a}', {a: t('status')})}>
                            {['active', 'inactive', 'defect'].map(status => {
                            return (
                                <>
                                    <option key={status} value={status}>{t(status)}</option>
                                </>
                            )
                            })}
                        </select>
                    </div>
                </div>

                <div className={"inb-form-group column medium-"+si+" small-"+si + " lang"}>
                    <label className="inb-form__controlLabel">{t('lock type',null,'capital')}</label>
                    <div className="inb-form__controllClass">
                        <select
                            className="inbooma-select-box__input"
                            name="lock_type"
                            onChange={e => onChangeForm(e)}
                            value={resource.lock_type}
                            disabled={!rbac.hasPermission('editStatus')}
                            placeholder={t('select_${a}', {a: t('lock type')})}>
                                <option key="lock_type_none" value={null}>Kein Schloss</option>
                                <option key="lock_type_hash" value="hash">Hash</option>
                                <option key="lock_type_token" value="token">Token</option>
                        </select>
                    </div>
                </div>

                {showLockKeys && <><div className={"inb-form-group column medium-"+si +" small-"+si+ " lang"}>
                    <label className="inb-form__controlLabel">{t('advertiser')}</label>
                    <div className="inb-form__controllClass">
                        <input type="text" className="form-control " name="advertiser" value={resource.advertiser === null ? "" : resource.advertiser} required="" onChange={onChangeForm}/>
                    </div>
                </div>
                    {resource.id !== null && resource.firmware !== null && <>
                        <div className="inb-form-group column medium-4 small-4 firmware">
                            <label className="inb-form__controlLabel">{t('firmware version')}</label>
                            <div className="inb-form__controllClass">
                                <input id="resource_item_input_firmware" type="text" className="form-control" name="firmware" required="" autoComplete="false"placeholder="" value={resource.firmware} disabled={true}/>
                            </div>
                        </div>
                    </>}
                <div className="inb-form-group column medium-6 small-6 lang">
                    <label className="inb-form__controlLabel">{t('change_key',null,'capital')}</label>
                    <div className="inb-form__controllClass">
                        { resource.lock_type == 'token' &&
                            <input title={t('change_key')} type="text" className="form-control" name="secret" value={resource.secret === null ? "" : resource.secret} onChange={onChangeForm} />
                        }
                        { resource.lock_type == 'hash' &&
                            <input title={t('change_key_warning',null,'capital')} type="text" className="form-control " name="lock_key" required="" value={resource.lock_key === null ? "" : resource.lock_key} onChange={onChangeForm} />
                        }
                    </div>
                </div>

                <div className="inb-form-group column medium-6 small-6 lang">
                    <label className="inb-form__controlLabel">{t('mac_adress') + " (MAC)"}</label>
                    <div className="inb-form__controllClass">
                        <input type="text" className="form-control " name="mac_adress" value={resource.mac === null ? "" : resource.mac} required="" onChange={onChangeForm}/>
                    </div>
                </div>

                </>}

                <div className="inb-form-group column medium-6 small-6 lang">
                    <label className="inb-form__controlLabel">{t('resource_nbr')}</label>
                    <div className="inb-form__controllClass">
                        <input type="text" className="form-control" name="resource_nbr" autoComplete="false" value={resource.resource_nbr === null ? "" : resource.resource_nbr } onChange={onChangeForm} placeholder=""/>
                    </div>
                </div>

                <div className="inb-form-group column medium-8 small-8 external_resource_id">
                    <label className="inb-form__controlLabel">{t('external resource id')}</label>
                    <div className="inb-form__controllClass">
                        <input id="resource_item_input_external_resource_id" type="text" className="form-control" name="external_resource_id" required="" autoComplete="false"placeholder="" value={resource.external_resource_id} onChange={onChangeForm}/>
                    </div>
                </div>

                {(Array.isArray(contingents) || resource.id !== null) &&
                <div className="inb-form-group column medium-12 small-12 lang"><label
                    className="inb-form__controlLabel">{t('contingent', null, 'capital')}</label>
                    <div className="inb-form__controllClass">
                        <select
                            className="inbooma-select-box__input"
                            name="contingents"
                            onChange={(e) => onChangeContingent(e)}
                            value={resource.contingent_id === null ? "" : resource.contingent_id}
                            placeholder={t('select_${a}', {a: t('contingent')})}>
                            <option key={0} value={0}> </option>
                            {contingents.map(contingent => {
                                return(
                                        <option key={contingent.id} value={contingent.id}>{contingent.name}</option>
                                )
                            })}
                        </select>

                    </div>
                </div>
                }
                {locations !== null &&
                <div className="inb-form-group column medium-12 small-12 lang"><label
                    className="inb-form__controlLabel">{t('resource_start_location', null, 'capital')}</label>
                    <div className="inb-form__controllClass">

                        <select
                            className="form-control"
                            name="resources"
                            value={resource.location_id === null ? "" : resource.location_id}
                            onChange={(e) => onChangeLocation(e)}
                            placeholder={t('select_${a}', {a: t('location')})}>
                            <option key={0} value={0}> </option>
                            {locations.map(location => {
                                return(
                                    <>
                                        <option  key={location.id} value={location.id}>{location.name}</option>
                                    </>
                                )
                            })}
                        </select>
                    </div>
                </div>
                }

                <div className="inb-form-group column medium-12 small-12 external_note"><label className="inb-form__controlLabel">{t('note',null,'capital')}</label>
                    <div className="inb-form__controllClass">
                        <textarea className="form-control " name="note" value={resource.note === null ? "" : resource.note} maxLength="4000" placeholder="" onChange={onChangeForm}/>
                    </div>
                </div>

                <div className="inb-forn-group column" style={{marginBottom:'10px',textDecoration:'underline'}}>
                    <label><a href={"/reservations/reservationsList?resource_id="+resource.id}>{t('past_reservations',null,'capital')}</a></label>
                </div>

                <div className="inb-form-group column medium-12 small-12"><label className="inb-form__controlLabel">{ t('defects')}</label>
                    <div className="inb-form__controllClass" style={{border:'1px solid #eee',padding:'0.5em 0.9em 0.7em 0.9em',fontSize:'0.8em'}}>
                        {resource.id !== '' && typeof resource.resource_defects !== 'undefined' &&  resource.resource_defects.length > 0 &&
                            <>
                                <div style={{fontWeight: 'bold',display:'flex',marginBottom: '10px',paddingLeft: '4px'}}>
                                    <div className="column medium-3 hide-for-small-only">{t('date',null,'capital')}</div>
                                    <div className="column medium-6 hide-for-small-only">{t('description',null,'capital')}</div>
                                    <div className="column medium-3 hide-for-small-only">{t('actions',null,'capital')}</div>
                                </div>
                                {resource.resource_defects.map((defect,index) => {
                                    return (
                                        <>
                                            <div className="inb-c-item inb-c-item--order row" style={{
                                                margin: '0 0 5px 0',
                                                backgroundColor: 'white',
                                                border: '1px solid #eee',
                                                padding: '5px 2px 5px 4px'
                                            }}>
                                                <div style={{
                                                    height: '1.5rem',
                                                    paddingTop: '4px'
                                                }} className="show-label column medium-3 small-12" title={t('date',null,'capital')}>{moment(defect.created).format(dateFormat(language, false))}</div>
                                                <div style={{
                                                    height: '1.5rem',
                                                    fontWeight: 'normal',
                                                    paddingTop: '4px'
                                                }} className="show-label column medium-6 small-12" title={t('description',null,'capital')}>
                                                    {defect.description}
                                                </div>
                                                <div style={{height: '1.5rem', paddingTop: '4px'}} className="show-label column medium-3 small-12" title={t('actions',null,'capital')}> <span
                                                    className="column medium-1 small-3" >
                                                <a href="#" onClick={(e) => {onShowResourceDefectsDialog(defect,index)}}>
                                                    <button type="button" className="inb-round-btn hollow round hide-for-small-only" style={{marginTop: "-15px"}}><div
                                                        className="inb-fi-edit"></div></button>
                                                    <button type="button" className="inb-round-btn hollow round show-for-small-only"><div
                                                        className="inb-fi-edit"></div></button>
                                                </a>
                                            </span><span
                                                    className="column medium-1 small-3">
                                                <a href="#" onClick={(e) => {del(defect.id,index)}}>
                                                    <button type="button" className="inb-round-btn hollow round hide-for-small-only" style={{marginTop: "-15px"}}><div
                                                        className="inb-fi-remove"></div></button>
                                                    <button type="button" className="inb-round-btn hollow round show-for-small-only"><div
                                                        className="inb-fi-remove"></div></button>
                                                </a></span></div>

                                            </div>
                                        </>
                                    );
                                })
                                }
                            </>}
                        <div style={{marginTop:'20px'}}>
                            <span>
                                <a href="#" onClick={(e) => {onShowResourceDefectsDialog(null,null)}}>
                                    <button type="button" className="inb-round-btn hollow round"> <i className="fi fi-plus"> </i> </button>
                                </a>
                            </span>
                        </div>
                    </div>
                </div>

                <div className="inb-form-group column medium-12 small-12"><label className="inb-form__controlLabel">Service</label>
                    <div className="inb-form__controllClass" style={{border:'1px solid #eee',padding:'0.5em 0.9em 0.7em 0.9em',fontSize:'0.8em'}}>
                        {resource.id !== '' && _tasks.success === true && _tasks.data !== 'undefined' && _tasks.data.length > 0 && itemState !=='pending_tasks' &&
                        <>
                            <div style={{fontWeight: 'bold',display:'flex',marginBottom: '10px',paddingLeft: '4px'}}>
                                <div className="column medium-3 hide-for-small-only">{t('task',null,'capital')}</div>
                                <div className="column medium-3 hide-for-small-only">{t('assignment',null,'capital')}</div>
                                <div className="column medium-2 hide-for-small-only">{t('date',null,'capital')}</div>
                                <div className="column medium-2 hide-for-small-only">{t('status',null,'capital')}</div>
                            </div>
                            {_tasks.data.map(task => {
                                if (task.team_lead === true) hasTaskTeamLead = true;
                                return(
                                    <>
                                        <div className="inb-c-item inb-c-item--order row" style={{margin: '0 0 5px 0',backgroundColor: 'white',border: '1px solid #eee',padding: '5px 2px 5px 4px'}}>
                                            <div style={{height: '1.5rem',paddingTop: '4px'}} className="show-label column medium-3 small-12" title={t('task',null,'capital')}>{task.name}</div>
                                            <div style={{height: '1.5rem',fontWeight: task.team_lead === true ? 'bold' : 'normal',paddingTop: '4px'}} className="show-label column medium-3 small-12" title={t('assignment',null,'capital')}>
                                                {task.user == null ? '' : ( (task.user.first_name != null ? task.user.first_name + ' ' : '') + (task.user.last_name != null ? task.user.last_name : '') )}
                                            </div>
                                            <div style={{height: '1.5rem',paddingTop: '4px'}} className="show-label column medium-2 small-12" title={t('date',null,'capital')}>{task.created != null ? moment(task.created).format('DD.MM.YYYY') : ''}<br/>{task.end != null ? moment(task.end).format('DD.MM.YYYY') : ''}</div>
                                            <div style={{height: '1.5rem',paddingTop: '4px'}} className="show-label column medium-2 small-12" title={t('status',null,'capital')}>{task.status == 'inprogress' ? t('in_progress') : t(task.status)}</div>
                                            <span className="column medium-2 small-12 float-right">
                                                <a href={"/tasks/" + task.id + "?path=/resources/" + resource.id} style={{float: 'right'}}>
                                                    <button type="button" className="inb-round-btn hollow round"><div className="inb-fi-edit"></div></button>
                                                </a>
                                            </span>
                                        </div>
                                    </>

                                )
                            })}
                        </>
                        }
                        <div style={{marginTop:'20px'}}>
                            { (typeof _tasks.data === 'undefined' || _tasks.data.length == 0) &&
                                <div style={{display:'inline-block',marginRight:'5%'}}><i>{t("still_no_service_team",null,'capital')}</i></div>
                            }
                            <span>
                                <a href={"/tasks/add?path=/resources/" + resource.id + "&lead=" + (hasTaskTeamLead === true ? 'false' : 'true') + "&fk_model=Resources&fk_id=" + resource.id}>
                                    <button type="button" className="inb-round-btn hollow round"> <i className="fi fi-plus"> </i> </button>
                                </a>
                            </span>
                        </div>
                    </div>
                </div>

            </form>
        </div>
        }
          {showResourceDefectsDialog &&
            <ResourceDefectsDialog
                resDefect={tempResourceDefect}
                setResource={setResource}
                index={tempIndex}
                add={(tempResourceDefect === null)}
                handleCloseDialog={handleCloseDialog}
                dispatch={props.dispatch}
                resource={resource}
                getUsernameById={getUsernameById}
                />
          }
          {showCheckinsDialog &&
              <CheckinsDialog
                  checkins={dialogCheckins}
                  resource={resource}
                  currentUrl={currentUrl}
                  setCheckins={setDialogCheckins}
                  handleCloseDialog={handleCloseDialog}
                  dispatch={props.dispatch}
                  getUsernameById={getUsernameById}
                  language={language}
              />
          }
      </>
    );
};

export default ItemView;